import React from "react";
import { Pill } from "components/SearchBar/Pill";
import styles from "./SubscriptionsTag.module.scss";

export default function SubscriptionsTag({ variant = "warn", text, isActive, onClick, customClassName }) {
  const className = isActive ? `${styles.pill} ${styles.pillActive}` : styles.pill;
  return (
    <Pill
      text={text}
      title={text}
      variant={variant}
      isActive={isActive}
      onClick={onClick}
      className={`${className} ${customClassName}`}
    />
  );
}
